import { useState } from "react"
import styles from "./update-tournament-modal.module.css"

export default function UpdateTournamentModal({ tournament, onClose, onUpdate }) {
	const [formData, setFormData] = useState({
		_id: tournament._id,
		name: tournament.name,
		description: tournament.description,
		prizePool: tournament.prizePool,
		rules: tournament.rules,
		bannerImage: tournament.bannerImage,
	})

	const [errors, setErrors] = useState({})

	const validateForm = () => {
		const newErrors = {}

		if (!formData.name.trim() || formData.name.length < 3 || formData.name.length > 100) {
			newErrors.name = "Tournament name must be 3-100 characters"
		}

		if (!formData.description.trim() || formData.description.length < 10 || formData.description.length > 1000) {
			newErrors.description = "Description must be 10-1000 characters"
		}

		if (!formData.prizePool.trim()) {
			newErrors.prizePool = "Prize pool is required"
		}

		if (!formData.rules.trim() || formData.rules.length < 10 || formData.rules.length > 2000) {
			newErrors.rules = "Rules must be 10-2000 characters"
		}

		setErrors(newErrors)
		return Object.keys(newErrors).length === 0
	}

	const handleChange = (e) => {
		const { name, value } = e.target
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}))
		if (errors[name]) {
			setErrors((prev) => ({
				...prev,
				[name]: "",
			}))
		}
	}

	const handleSubmit = (e) => {
		e.preventDefault()
		if (validateForm()) {
			onUpdate(formData)
			onClose()
		}
	}

	return (
		<div className={styles.modalOverlay} onClick={onClose}>
			<div className={styles.modal} onClick={(e) => e.stopPropagation()}>
				<div className={styles.modalHeader}>
					<h2>Update Tournament</h2>
					<button className={styles.closeButton} onClick={onClose}>
						✕
					</button>
				</div>

				<form className={styles.form} onSubmit={handleSubmit}>
					{/* Tournament Name */}
					<div className={styles.formGroup}>
						<label htmlFor="name">Tournament Name *</label>
						<input
							type="text"
							id="name"
							name="name"
							value={formData.name}
							onChange={handleChange}
							placeholder="Enter tournament name"
							maxLength="100"
							className={errors.name ? styles.inputError : ""}
						/>
						<div className={styles.charCount}>{formData.name.length}/100</div>
						{errors.name && <span className={styles.error}>{errors.name}</span>}
					</div>

					{/* Description */}
					<div className={styles.formGroup}>
						<label htmlFor="description">Description *</label>
						<textarea
							id="description"
							name="description"
							value={formData.description}
							onChange={handleChange}
							placeholder="Enter tournament description"
							maxLength="1000"
							rows="4"
							className={errors.description ? styles.textareaError : ""}
						/>
						<div className={styles.charCount}>{formData.description.length}/1000</div>
						{errors.description && <span className={styles.error}>{errors.description}</span>}
					</div>

					{/* Prize Pool */}
					<div className={styles.formGroup}>
						<label htmlFor="prizePool">Prize Pool *</label>
						<input
							type="text"
							id="prizePool"
							name="prizePool"
							value={formData.prizePool}
							onChange={handleChange}
							placeholder="e.g., 1st: ₹25,000 | 2nd: ₹15,000 | 3rd: ₹10,000"
							className={errors.prizePool ? styles.inputError : ""}
						/>
						{errors.prizePool && <span className={styles.error}>{errors.prizePool}</span>}
					</div>

					{/* Rules */}
					<div className={styles.formGroup}>
						<label htmlFor="rules">Rules *</label>
						<textarea
							id="rules"
							name="rules"
							value={formData.rules}
							onChange={handleChange}
							placeholder="Enter tournament rules"
							maxLength="2000"
							rows="5"
							className={errors.rules ? styles.textareaError : ""}
						/>
						<div className={styles.charCount}>{formData.rules.length}/2000</div>
						{errors.rules && <span className={styles.error}>{errors.rules}</span>}
					</div>

					{/* Banner Image */}
					<div className={styles.formGroup}>
						<label htmlFor="bannerImage">Banner Image URL *</label>
						<input
							id="bannerImage"
							type="text"
							name="bannerImage"
							value={formData.bannerImage}
							onChange={handleChange}
							placeholder="https://example.com/banner.jpg"
							className={`${styles.input} ${errors.bannerImage && touched.bannerImage ? styles.error : ""}`}
						/>
						{formData.bannerImage!=="undefined" && formData.bannerImage && (
							<div className={styles.imagePreview}>
								<img src={formData.bannerImage || "/placeholder.webp"} alt="Banner preview" />
							</div>
						)}
					</div>

					{/* Buttons */}
					<div className={styles.formButtons}>
						<button type="button" className={styles.cancelButton} onClick={onClose}>
							Cancel
						</button>
						<button type="submit" className={styles.updateButton}>
							Update Tournament
						</button>
					</div>
				</form>
			</div>
		</div>
	)
}
